import { createStyles, alpha, makeStyles, Theme } from '@material-ui/core/styles';

export type RoleTier = 'admin' | 'manager' | 'supervisor' | 'basic' | 'none';

export const getRoleTier = (roleName?: string | null): RoleTier => {
  if (!roleName) return 'none';
  if (/owner|admin|full access/i.test(roleName)) return 'admin';
  if (/manager/i.test(roleName)) return 'manager';
  if (/supervisor/i.test(roleName)) return 'supervisor';
  return 'basic';
};

export const useRoleChipStyles = makeStyles((theme: Theme) => {
  const dark = theme.palette.type === 'dark';
  return createStyles({
    chip: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '5px 12px',
      borderRadius: 999,
      fontSize: 12.5,
      fontWeight: 600,
      lineHeight: 1.4,
      whiteSpace: 'nowrap',
      fontFamily: theme.typography.fontFamily,
      border: 'none',
    },
    admin: {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, dark ? 0.16 : 0.08),
    },
    manager: {
      color: theme.palette.secondary.main,
      backgroundColor: alpha(theme.palette.secondary.main, dark ? 0.16 : 0.08),
    },
    supervisor: {
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, dark ? 0.2 : 0.12),
    },
    basic: {
      color: theme.palette.text.secondary,
      backgroundColor: alpha(theme.palette.text.secondary, 0.12),
    },
    none: {
      color: theme.palette.text.disabled,
      backgroundColor: alpha(theme.palette.text.secondary, 0.06),
    },
  });
});
